export enum ProxyRuleStatus {
    Created = 'created',
    Verifying = 'verifying',
    Verified = 'verified',
    Unverified = 'unverified',
}